import { DateTime } from 'luxon';
import axios from '../axios';
import * as html from '../html';
import { IconMarkup } from '../icons';
import i18n from './i18n';
import Modal from '../modal';
import * as models from './models';

// The other active orders in the network from the last 180 days that carry any of these PO numbers.
export async function FindPurchaseOrderDuplicates(opts: {
    networkID: string;
    purchaseOrderNumbers: string[];
    excludeOrderID?: string;
}): Promise<models.Order[]> {
    const purchaseOrderNumbers = Array.from(new Set(opts.purchaseOrderNumbers.
        map(purchaseOrderNumber => purchaseOrderNumber.trim()).
        filter(purchaseOrderNumber => purchaseOrderNumber !== '')));
    if (purchaseOrderNumbers.length === 0 || opts.networkID === '') {
        return [];
    }
    const params: {
        networkID: string;
        purchaseOrderNumbers: string[];
        excludeOrderID?: string;
    } = {
        networkID: opts.networkID,
        purchaseOrderNumbers,
    };
    if (opts.excludeOrderID) {
        params.excludeOrderID = opts.excludeOrderID;
    }
    const resp = await axios.get('/v2/orders/purchase-order-duplicates', { params });
    const data = models.PurchaseOrderDuplicatesResponse.fromJSON(resp.data);
    return data.duplicates;
}

// Shows the list and resolves true when the user confirms, false when they dismiss.
export async function ConfirmPurchaseOrderDuplicates(orders: models.Order[]): Promise<boolean> {
    const $body = document.createElement('ul');
    // Inline: legacy IAP's spacing utilities aren't Bootstrap 5's.
    $body.style.paddingLeft = '1rem';

    const purchaseOrderNumbers: string[] = [];
    const seenPurchaseOrderNumbers = new Set<string>();
    for (const order of orders) {
        for (const orderPayment of order.orderPayments) {
            const key = orderPayment.purchaseOrderNumber.toLowerCase();
            if (seenPurchaseOrderNumbers.has(key)) {
                continue;
            }
            seenPurchaseOrderNumbers.add(key);
            purchaseOrderNumbers.push(orderPayment.purchaseOrderNumber);
        }

        const created = order.created.isValid ? order.created.toLocaleString(DateTime.DATE_SHORT) : '';
        const $order = html.FromString(`<li>
            <a href="${html.Escape(order.iapURL())}" target="_blank">
                ${order.invoiceNumber} - ${created} - ${html.Escape(order.name || i18n('untitled'))}
                ${IconMarkup({ fa4: 'fa-external-link', fa5: 'fa-external-link-alt', attrs: 'aria-hidden="true"' })}
            </a>
        </li>`);
        $body.appendChild($order);
    }

    const modal = new Modal({
        title: i18n('poDuplicatesTitle').replace('%s', purchaseOrderNumbers.join(', ')),
        confirmText: i18n('poDuplicatesConfirm'),
        body: $body,
    });
    // Dismissing never settles modal.promise, only closedPromise, so the race
    // maps a cancel to false. On confirm, promise resolves first and wins.
    return Promise.race([
        modal.promise.then(() => true),
        modal.closedPromise.then(() => false),
    ]);
}
